var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-card"},[_c('h2',{staticClass:"card-title"},[_vm._t("title")],2),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }